import React from 'react'
import { toDate } from 'util/date/formatDate'
import { AlertImc } from 'view/atendimentos/detail/soap/aside/medicoes/components/AlertImc'
import { ParticipanteModel } from 'view/atividade-coletiva/model-atividadeColetiva'
import { formatImcParticipante } from 'view/atividade-coletiva/utils-atividadeColetiva'

interface ParticipanteImcAlertProps {
  participante: ParticipanteModel
  dataAtividade: LocalDate | number
}

export const ParticipanteImcAlert = ({ participante, dataAtividade }: ParticipanteImcAlertProps) => {
  const imc = formatImcParticipante(participante)

  if (!imc) return <></>

  const cidadao = participante.cidadao ?? participante.cidadaoParticipante

  return (
    <AlertImc
      dataMedicao={toDate(dataAtividade).getTime()}
      imc={imc}
      dataNascimento={cidadao.dataNascimento}
      sexo={cidadao.sexo}
    />
  )
}
